<div class="" *ngIf="delayFailures?.length > 0; else noFailures">
  <p-table
    #dt
    [value]="delayFailures"
    [loading]="loading"
    [resizableColumns]="true"
    [styleClass]="'no-border-table'"
    tableStyleClass="table-no-top-corners"
    [responsive]="true"
  >
    <ng-template pTemplate="header">
      <tr>
        <th pResizableColumn>Registration</th>
        <th pResizableColumn>Delay/Failure Date</th>
        <th pResizableColumn>Delay/Failure Reason</th>
        <th pResizableColumn>Added By</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-item>
      <tr>
        <td>
          <div>{{ item.vrm }}</div>
        </td>
        <td>
          <div>{{ item.addedDate | datex : "ddd DD MMM 'YY HH:mm" }}</div>
        </td>
        <td>
          <div>{{ item.delayFailureCategory?.category }}</div>
        </td>
        <td>
          <div>{{ item.addedByUserName }}</div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<ng-template #noFailures>
  <div style="height: 75px; display: flex; flex; align-items: center;">
    <div class="text-center flex-grow-1">No Job Delays / Failures</div>
  </div>
</ng-template>
